// extracted by mini-css-extract-plugin
module.exports = {"map-drawing__svg":"map-drawing_map-drawing__svg__WM5_y"};